import React from "react";

/**
 * Minimalist lightning bolt — single-line outline, thin stroke.
 * Drop-in replacement for lucide's <Zap /> in marketing/hero locations
 * where the bold Zap looks too playful. Functional spots (AutoPay button,
 * alerts) keep the original Zap.
 *
 * Usage: <VoltIcon className="w-4 h-4 text-velcor-green" />
 */
export default function VoltIcon({ className = "", strokeWidth = 1.4, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...props}
    >
      <path d="M13.5 3 L5 13.5 H11 L10.5 21 L19 10.5 H13 L13.5 3 Z" />
    </svg>
  );
}
